import { render, staticRenderFns } from "./FilesModal.vue?vue&type=template&id=0a2c6043"
import script from "./FilesModal.vue?vue&type=script&lang=js"
export * from "./FilesModal.vue?vue&type=script&lang=js"
import style0 from "./FilesModal.vue?vue&type=style&index=0&id=0a2c6043&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports